/**
 * @param {string} key
 * @param {object} data
 * @param {string} data.activeView
 * @param {object} data.selectedCategoryId
 */
export function saveViewInfo(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
}

export function loadViewInfo(key, stageId, projectId) {
    try {
        const objectString = localStorage.getItem(key);
        const jsonObj = JSON.parse(objectString);
        if(jsonObj.stageId === stageId && jsonObj.projectId === projectId)
            return jsonObj;
    } catch {
        // ignored
    }
    return null;
}